import { useState } from "react";
import { Link } from "react-router-dom";
import { Bookmark, Check, StickyNote } from "lucide-react";
import { Input } from "@/components/ui/input";

/* A saved commentary section on My Study, with a one-line "why I saved this" note. */
export function SavedCommentaryCard({ b, onRemove, onNote, saving }) {
  const [editing, setEditing] = useState(false);
  const [note, setNote] = useState(b.note || "");
  const save = async () => { if (note.trim() !== (b.note || "")) await onNote(note.trim()); setEditing(false); };
  return (
    <div className="rounded-2xl border border-border bg-card p-4 transition-all hover:border-gold hover:shadow-md" data-testid={`saved-commentary-${b.section_id}`}>
      <div className="flex items-start justify-between gap-3">
        <Link to={b.href} className="min-w-0 flex-1">
          <p className="no-reftag font-mono text-[10px] uppercase tracking-wider text-gold">{b.commentary_name} · {b.reference}</p>
          <p className="mt-1 font-serif text-lg leading-tight text-foreground">{b.title || `${b.commentary_name} on ${b.reference}`}</p>
        </Link>
        <button type="button" onClick={onRemove} aria-label="Remove saved commentary" className="rounded-full p-1.5 text-gold hover:bg-muted" data-testid={`saved-commentary-remove-${b.section_id}`}><Bookmark className="h-4 w-4" fill="currentColor" /></button>
      </div>
      {editing ? (
        <form onSubmit={(e) => { e.preventDefault(); save(); }} className="mt-3 flex items-center gap-2">
          <Input autoFocus value={note} maxLength={240} onChange={(e) => setNote(e.target.value)} onBlur={save} onKeyDown={(e) => e.key === "Escape" && setEditing(false)} placeholder="Why I saved this…" className="h-8 text-sm" data-testid={`saved-commentary-note-input-${b.section_id}`} />
          <button type="submit" disabled={saving} aria-label="Save note" className="rounded-full p-1.5 text-gold hover:bg-muted" data-testid={`saved-commentary-note-save-${b.section_id}`}><Check className="h-4 w-4" /></button>
        </form>
      ) : (
        <button type="button" onClick={() => setEditing(true)} className="mt-3 flex w-full items-start gap-1.5 text-left text-sm text-muted-foreground hover:text-foreground" data-testid={`saved-commentary-note-${b.section_id}`}>
          <StickyNote className="mt-0.5 h-3.5 w-3.5 shrink-0 text-gold" />
          {b.note ? <span className="italic text-foreground/85">{b.note}</span> : <span>Add a note — why I saved this</span>}
        </button>
      )}
    </div>
  );
}
